import { ProductFullType } from '@client/product/redux/products/full/types';

export enum FIELD_NAME {
  additionalComments = 'additionalComments',
  additionalImages = 'additionalImages',
  description = 'description',
  energyLabel = 'energyLabel',
  fixedPrices = 'fixedPrices',
  fixedPricesTaxValue = 'fixedPricesTaxValue',
  listPrice = 'listPrice',
  listPriceWithoutVat = 'listPriceWithoutVat',
  mainImage = 'mainImage',
  manufacturerNumber = 'manufacturerNumber',
  offer = 'offer',
  offerPriceValue = 'offerPriceValue',
  offerValue = 'offerValue',
  productName = 'productName',
  shortInfo = 'shortInfo',
  sku = 'sku',
  specification = 'specification',
  userPrice = 'userPrice',
  userPriceWithoutVat = 'userPriceWithoutVat',
  warrantyInfo = 'warrantyInfo',
  withoutVAT = 'withoutVAT',
  withVAT = 'withVAT',
}

export type FormValuesType = {
  [FIELD_NAME.additionalComments]: string,
  [FIELD_NAME.additionalImages]: boolean,
  [FIELD_NAME.description]: boolean,
  [FIELD_NAME.fixedPrices]: boolean,
  [FIELD_NAME.fixedPricesTaxValue]: string[],
  [FIELD_NAME.mainImage]: boolean,
  [FIELD_NAME.manufacturerNumber]: boolean,
  [FIELD_NAME.offer]: boolean,
  [FIELD_NAME.offerPriceValue]: string,
  [FIELD_NAME.offerValue]: string[],
  [FIELD_NAME.productName]: boolean,
  [FIELD_NAME.shortInfo]: boolean,
  [FIELD_NAME.sku]: boolean,
  [FIELD_NAME.specification]: boolean,
  [FIELD_NAME.warrantyInfo]: boolean,
}

export interface Props {
  className?: string;
  toggleModal: () => void;
  product: ProductFullType;
}
